<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%" @close="handleClose"
    :close-on-click-modal="false">
    <el-form :model="currentData" label-width="100px" ref="form" :rules="rules" v-loading="formLoadng">

      <el-form-item label="名称：" prop="name">
        <el-input size="mini" v-model="currentData.name" />
      </el-form-item>

      <!-- 绑定设备 -->
      <el-form-item label="绑定设备：" prop="bind_dev">
        <el-checkbox v-model="currentData.bind_dev"></el-checkbox>
      </el-form-item>

      <!-- 设备地址 -->
      <el-form-item label="设备地址：" prop="dev_addr" v-if="currentData.bind_dev">
        <el-select v-model="currentData.dev_addr" size="mini">
          <el-option v-for="item in ipList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- 只写指令 -->
      <el-form-item label="只写指令：" prop="only_write">
        <el-checkbox v-model="currentData.only_write"></el-checkbox>
        <p class="tips">
          不主动采集数据，只用于写操作
        </p>
      </el-form-item>

      <el-form-item label="采集周期：" prop="interval" v-if="!currentData.only_write">
        <el-input size="mini" v-model="currentData.interval" />
        <p class="tips">秒，最低值：5</p>
      </el-form-item>

      <el-form-item label="从站ID：" prop="slaveid">
        <el-input size="mini" v-model="currentData.slaveid" />
        <p class="tips">
          取值范围: 1 ~ 255
        </p>
      </el-form-item>

      <el-form-item label="功能码：" prop="function">
        <el-select size="mini" v-model="currentData.function" style="width: 100%;" placeholder="请选择">
          <el-option v-for="item in functionCode" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="起始地址：" prop="start">
        <el-input size="mini" v-model="currentData.start" />
        <p class="tips">
          取值范围: 0 ~ 65535
        </p>
      </el-form-item>

      <el-form-item label="数据类型：" prop="datatype">
        <el-select size="mini" v-model="currentData.datatype" style="width: 100%;" placeholder="请选择">
          <el-option v-for="item in dataTypeList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="精度" prop="precise"
        v-if="currentData.datatype === 'float' || currentData.datatype === 'double'">
        <el-input size="mini" v-model="currentData.precise" placeholder="请输入"></el-input>
        <p class="tips">取值范围: 1 ~ 6</p>
      </el-form-item>

      <el-form-item label="数据长度：" prop="size">
        <el-input size="mini" v-model="currentData.size" />
        <p class="tips">取值范围: 1 ~ 30</p>
      </el-form-item>

      <!-- 字节序 -->
      <el-form-item label="字节序：" prop="endian">
        <el-select size="mini" v-model="currentData.endian">
          <el-option v-for="item in byteList" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="计算因子：" prop="factor" v-if="!['bool', 'string', 'raw', ''].includes(currentData.datatype)">
        <el-input size="mini" v-model="currentData.factor" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 缓存指令 -->
      <el-form-item label="缓存指令：" prop="buff_cmd">
        <el-checkbox v-model="currentData.buff_cmd"></el-checkbox>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmAdd">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listConfig, updateConfig } from "@/api/configurationlist";
export default {
  data() {
    var validateslaveid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入从站ID'));
      } else if (isNaN(value)) {
        callback(new Error('请输入1-255之间的数字'));
      } else if (value < 1 || value > 255) {
        callback(new Error('从站ID范围1-255'));
      } else {
        callback();
      }
    };
    var validatestart = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入起始地址'));
      } else if (isNaN(value)) {
        callback(new Error('请输入0-65535之间的数字'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('起始地址范围0-65535'));
      } else {
        callback();
      }
    };
    var validateprecise = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入精度'));
      } else if (isNaN(value)) {
        callback(new Error('精度范围1-6'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('精度范围1-6'));
      } else {
        callback();
      }
    };
    var validatefactor = (rule, value, callback) => {
      // 必须为正整数
      if (value === '') {
        callback(new Error('请输入计算因子'));
      } else if (isNaN(value)) {
        callback(new Error('计算因子必须为数字'));
      } else {
        callback();
      }
    }
    var validatesize = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入数据长度'));
      } else if (isNaN(value)) {
        callback(new Error('数据长度范围1-30'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('数据长度范围1-30'));
      } else {
        callback();
      }
    };
    return {
      currentData: {
        name: '',
        dev_addr: '',
        interval: '5',
        slaveid: '',
        function: '1',
        start: '',
        datatype: '',
        size: '',
        precise: '',
        factor: '',
        sname: undefined,
        index: undefined,
        bind_dev: false,
        endian: 'ABCD',
        only_write: false,
        buff_cmd: false
      },
      ipList: [],
      dialogTitle: '编辑',
      formLoadng: false,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        datatype: [
          { required: true, message: '请选择数据类型', trigger: 'change' }
        ],
        dev_addr: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        slaveid: [
          { validator: validateslaveid, trigger: 'blur' }
        ],
        start: [
          { validator: validatestart, trigger: 'blur' }
        ],
        precise: [
          { validator: validateprecise, trigger: 'blur' }
        ],
        size: [
          { validator: validatesize, trigger: 'blur' }
        ],
        factor: [
          { validator: validatefactor, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      functionCode: [
        {
          label: '1（读线圈）',
          value: '1'
        },
        {
          label: '2（读输入状态）',
          value: '2'
        },
        {
          label: '3（读保持寄存器）',
          value: '3'
        },
        {
          label: '4（读输入寄存器）',
          value: '4'
        },
      ],
      byteList: [
        {
          label: 'ABCD',
          value: 'ABCD'
        },
        {
          label: 'CDAB',
          value: 'CDAB'
        },
        {
          label: 'DCBA',
          value: 'DCBA'
        },
        {
          label: 'BADC',
          value: 'BADC'
        },
      ]
    };
  },
  props: ['deviceSn', 'deviceDid'],
  methods: {
    async getDevIp() {
      const resp = await listConfig(this.deviceSn, this.deviceDid, [
        {
          "section": "conn",
          config: "smartlink",
          options: [
            {
              option: 'mode'
            },
            {
              option: 'dev_name'
            }
          ],
          lists: [
            {
              list: 'slave_addr'
            }
          ]
        }
      ])
      if (!resp.data.success) {
        return this.$message.error('操作失败')
      }
      let sml = resp.data.data.mess[0].s_objects;
      sml.forEach((item) => {
        if (item.options.mode === 'Modbus RTU Master' || item.options.mode === 'Modbus TCP Master') {
          if (item.options.dev_name != '') {
            this.ipList.push({
              label: item.options.dev_name,
              value: item.options.dev_name
            })
          }
          this.ipList.push(...item.lists.slave_addr.map((e) => {
            return {
              label: e,
              value: e
            }
          }))
        }
      })

    },
    handleClose() {

    },
    async confirmAdd() {
      this.$emit('update',this.currentData)
    }
  },
  mounted() {
    this.getDevIp()
  },
  computed: {
    dataTypeList() {
      switch (this.currentData.function) {
        case "1":
        case "2":
          return [
            {
              label: 'bool',
              value: 'bool'
            }
          ]
        case "3":
        case "4":
          return [
            {
              label: 'int16',
              value: 'int16'
            },
            {
              label: 'uint16',
              value: 'uint16'
            },
            {
              label: 'int32',
              value: 'int32'
            },
            {
              label: 'uint32',
              value: 'uint32'
            },
            {
              label: 'int64',
              value: 'int64'
            },
            {
              label: 'uint64',
              value: 'uint64'
            },
            {
              label: 'float',
              value: 'float'
            },
            {
              label: 'double',
              value: 'double'
            },
            {
              label: 'string',
              value: 'string'
            },
            {
              label: 'raw',
              value: 'raw'
            }
          ]
      }
    }
  },
};
</script>
<style scoped></style>